import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import type React from "react";
import { PdfExportService } from "app/services/PdfExportService";
import { allTrackers } from "app/services/track/track";

interface PngDownloadProps {
    chartRef: React.RefObject<HTMLElement | null>;
    metricName: string;
    offset?: { x: number; y: number };
    tracking?: () => void;
}

export const PngDownload: React.FC<PngDownloadProps> = ({
    chartRef,
    metricName,
    offset = { x: 0, y: 0 },
    tracking,
}) => {
    const getPNG = (): Promise<void> => {
        const styleHTML = PdfExportService.getStylesheetsForPng();
        let height = chartRef?.current?.offsetHeight + 30;
        height = isNaN(height) ? 400 : height;
        return PdfExportService.downloadHtmlPngFedService(
            styleHTML + chartRef.current.outerHTML,
            metricName,
            1366 + offset.x,
            height + offset.y,
        );
    };

    const pngTracking = () => {
        allTrackers.dispatchTrackEvent(
            "Download",
            "submit-ok",
            `Over Time Graph/Search Overview/${metricName || ""}/Png`,
        );
    };

    return (
        <DownloadButtonMenu
            PNG={true}
            handleDownloadFunction={getPNG}
            trackingFunction={tracking ?? pngTracking}
        />
    );
};
